import { call, put, select } from 'redux-saga/effects';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import { setBannerAPIRequestState } from '../../../effects/message';
import getApplications from './getApplications';
import AnalyticsService from '../../../../services/analytics.service';
import AnalyticsEvents from '../../../../services/analytics.constants';

export default function* updateApplication({ payload }) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const { appId, settings } = payload;
  const { uuid } = yield select((state) =>
    state.organization.applications.content.find((app) => appId === app.id),
  );
  const url = `${dpaApiBaseUrl + RESOURCES.V2}/applications/${appId}`;
  const { success, error } = yield call(callAPI, {
    url,
    method: METHODS.PUT,
    body: settings,
  });
  if (!error && success) {
    // TBD update application success
    yield put(
      setBannerAPIRequestState({
        bannerState: 'success',
        bannerMessage: 'Changes has been saved!',
      }),
    );
    const changes = Object.keys(settings);
    AnalyticsService.track(AnalyticsEvents.AppUpdated, {
      uuid,
      appId,
      changes,
    });
    yield call(getApplications);
  } else {
    console.error(error);
    yield put(
      setBannerAPIRequestState({
        bannerState: 'error',
        bannerMessage:
          'Something went wrong while updating your application information...',
      }),
    );
  }
}
